/*
 * File: /src/store/modules/tags.js
 * Created Date: Sunday November 15th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 15th November 2020 11:44:26 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import contactServices from 'src/services/contactServices';
import tagService from 'src/services/tagService';

const state = {
  tags: undefined,
  // Last saved tag set for a contact so every view showing that contact's tags,
  // ie the hero tags and tag cards, stays in sync. { contactId, tags: [{ id }] }
  contactTagChange: undefined,
};
const getters = {
  getTagById: state => id => {
    return state.tags.find(tag => {
      if (parseInt(tag.id, 10) === parseInt(id, 10)) {
        return tag;
      }
    });
  },
  getTagLabelById: state => id => {
    return state.tags.find(tag => {
      if (parseInt(tag.id, 10) === parseInt(id, 10)) {
        return tag;
      }
    });
  },
  getTags: state => state.tags,
  getContactTagChange: state => state.contactTagChange,
};
const actions = {
  async fetchTags({ commit }) {
    if (state.tags == undefined) {
      return tagService.fetchTags(false, 200)
        .then(r => {
          let tags = [];
          for (const inc in r.data) {
            if (r.data[inc].active == false) {
              continue;
            }
            tags.push(Object.assign({}, r.data[inc]));
          }
          const tagStore = Object.assign([], tags);
          commit('storeTags', tagStore);
        });
    }
  },
  // Refetch and swap in the new tags so the store is never empty in between,
  // ie after a tag is edited
  async reloadTags({ commit }) {
    const r = await tagService.fetchTags(false, 200);
    commit(
      'storeTags',
      r.data.filter((t) => t.active != false).map((t) => Object.assign({}, t))
    );
  },
  // Share a contact's newly saved tags with every view showing them and drop
  // the cached contact so later loads, ie incoming calls, get the new tags
  publishContactTags({ commit, dispatch }, { contactId, tags }) {
    commit('contactTagsChanged', { contactId, tags });
    dispatch('contacts/deleteContactCache', +contactId, { root: true });
  },
  unloadTags({ commit }) {
    commit('storeTags', undefined);
  },
};
const mutations = {
  storeTags(state, tags) {
    state.tags = tags ? Object.assign([], tags) : undefined
  },
  // Always a new object so watchers fire even for the same contact and tags
  contactTagsChanged(state, { contactId, tags }) {
    state.contactTagChange = {
      contactId: +contactId,
      tags: tags.map((t) => ({ id: +(typeof t === 'object' ? t.id : t) })),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
